import axios from "axios";
import { AccessTokenInterceptor } from "./interceptors";

const getInstance = () => {
  const instance = axios.create({
    // baseURL: "https://cors-anywhere.herokuapp.com/" + window.domain,
    // baseURL: process.env["REACT_APP_API_HOST_URL"],
    baseURL: "https://salesinfinityx.com",
    // baseURL: "https://dev.salesinfinityx.com",
    timeout: 300000,
    withCredentials: true,
  });

  //   instance.interceptors.response.use(
  //     UnauthorizeInterceptor.onFullfilled,
  //     UnauthorizeInterceptor.onRejected
  //   );

  instance.interceptors.request.use(
    AccessTokenInterceptor.addAccessToken,
    AccessTokenInterceptor.onRejected
  );

  //   instance.interceptors.request.use(AddTokenToURL.addAccessToken);

  //   instance.interceptors.request.use(PermissionInterceptor.checkPermission);

  //   instance.interceptors.request.use(LanguageInterceptor.addLanguage);

  return instance;
};

export const API = getInstance();
